import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-blue-600 to-indigo-600 min-h-screen" }
const _hoisted_2 = { class: "bg-white shadow-md w-full" }
const _hoisted_3 = { class: "container mx-auto py-3 px-4" }
const _hoisted_4 = { class: "flex flex-col md:flex-row md:justify-between md:items-center py-2" }
const _hoisted_5 = { class: "flex flex-col md:flex-row justify-between items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 text-xl font-bold md:text-2xl hover:text-gray-700" }, "Galia")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "md:ml-8"
}
const _hoisted_8 = { class: "flex justify-start flex-row mt-2 md:mt-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "User", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Admin", -1)
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col mt-2 md:flex-row md:ml-8 md:mt-0 md:mx-1"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Overview")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("My Report")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("My Absences")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Projects")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Absences Calendar")
const _hoisted_17 = {
  key: 1,
  class: "flex flex-col mt-2 md:flex-row md:ml-8 md:mt-0 md:mx-1"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Schedule")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Absences")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Reports")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Locks")
const _hoisted_22 = { class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Exports", -1)
const _hoisted_24 = { class: "px-1 py-1" }
const _hoisted_25 = { class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Imports", -1)
const _hoisted_27 = { class: "px-1 py-1" }
const _hoisted_28 = { class: "md:flex items-center" }
const _hoisted_29 = { class: "flex flex-col md:flex-row items-center -mx-1 mt-4 md:mt-0" }
const _hoisted_30 = {
  key: 0,
  class: "text-center text-sm text-gray-700 leading-5 md:mx-4 mb-1 md:mb-0",
  href: "#"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Logout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_app_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSwitchMenuClick(_ctx.MenuView.User))),
                      type: "gray",
                      padding: "small",
                      class: _normalizeClass(['w-full sm:w-auto border-r-0 rounded-r-none', _ctx.menuView == _ctx.MenuView.User && 'bg-gray-200 hover:bg-gray-200'])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_app_button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSwitchMenuClick(_ctx.MenuView.Admin))),
                      type: "gray",
                      padding: "small",
                      class: _normalizeClass(['w-full sm:w-auto rounded-l-none', _ctx.menuView == _ctx.MenuView.Admin && 'bg-gray-200 hover:bg-gray-200'])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_ctx.menuView == _ctx.MenuView.User)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: {name: 'Overview'},
                      class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                      "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: {name: 'My Report'},
                      class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                      "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: {name: 'My Absences'},
                      class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                      "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: {name: 'Projects'},
                      class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                      "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: {name: 'AbsencesCalendar'},
                      class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                      "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.isAdmin && _ctx.menuView == _ctx.MenuView.Admin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_router_link, {
                        to: {name: 'Schedule'},
                        class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                        "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: {name: 'Absences'},
                        class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                        "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: {name: 'Reports'},
                        class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                        "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: {name: 'Locks'},
                        class: "inline-flex items-center justify-center px-3 py-2 rounded-md my-1 text-center text-sm text-blue-600 leading-5 md:mx-2 md:my-0 hover:text-blue-700 hover:bg-indigo-100",
                        "active-class": "bg-indigo-100 text-blue-700 font-semibold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Menu, {
                        as: "div",
                        class: "relative inline-block text-left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_MenuButton, null, {
                              default: _withCtx(() => [
                                _createElementVNode("button", _hoisted_22, [
                                  _hoisted_23,
                                  _createVNode(_component_ChevronDownIcon, { class: "h-5 w-5 ml-1 -mr-1" })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-100 ease-out",
                            "enter-from-class": "transform scale-95 opacity-0",
                            "enter-to-class": "transform scale-100 opacity-100",
                            "leave-active-class": "transition duration-75 ease-in",
                            "leave-from-class": "transform scale-100 opacity-100",
                            "leave-to-class": "transform scale-95 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, {
                                style: {"z-index":"9999"},
                                class: "absolute left-0 w-44 mt-2 origin-top-left bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_MenuItem, null, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("button", {
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({name: 'ExportProjTool'}))),
                                          class: _normalizeClass([
                              active && 'bg-indigo-100',
                              'group flex rounded-md items-center w-full px-2 pl-4 py-2 text-sm text-blue-700',
                            ])
                                        }, " ProjTool ", 2)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_MenuItem, null, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("button", {
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push({name: 'ExportAbraWork'}))),
                                          class: _normalizeClass([
                              active && 'bg-indigo-100',
                              'group flex rounded-md items-center w-full px-2 pl-4 py-2 text-sm text-blue-700',
                            ])
                                        }, " ABRA Work ", 2)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_MenuItem, null, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("button", {
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({name: 'ExportVch'}))),
                                          class: _normalizeClass([
                              active && 'bg-indigo-100',
                              'group flex rounded-md items-center w-full px-2 pl-4 py-2 text-sm text-blue-700',
                            ])
                                        }, " VCH Report ", 2)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_MenuItem, null, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("button", {
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push({name: 'ExportIco'}))),
                                          class: _normalizeClass([
                              active && 'bg-indigo-100',
                              'group flex rounded-md items-center w-full px-2 pl-4 py-2 text-sm text-blue-700',
                            ])
                                        }, " ICO Report ", 2)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Menu, {
                        as: "div",
                        class: "relative inline-block text-left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_MenuButton, null, {
                              default: _withCtx(() => [
                                _createElementVNode("button", _hoisted_25, [
                                  _hoisted_26,
                                  _createVNode(_component_ChevronDownIcon, { class: "h-5 w-5 ml-1 -mr-1" })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-100 ease-out",
                            "enter-from-class": "transform scale-95 opacity-0",
                            "enter-to-class": "transform scale-100 opacity-100",
                            "leave-active-class": "transition duration-75 ease-in",
                            "leave-from-class": "transform scale-100 opacity-100",
                            "leave-to-class": "transform scale-95 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, {
                                style: {"z-index":"9999"},
                                class: "absolute left-0 w-44 mt-2 origin-top-left bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_component_MenuItem, null, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("button", {
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.router.push({name: 'ImportAnnotators'}))),
                                          class: _normalizeClass([
                              active && 'bg-indigo-100',
                              'group flex rounded-md items-center w-full px-2 pl-4 py-2 text-sm text-blue-700',
                            ])
                                        }, " Annotators ", 2)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              (_ctx.user)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.user.surname) + " " + _toDisplayString(_ctx.user.name), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_app_button, {
                onClick: _ctx.onLogoutClick,
                type: "red"
              }, {
                default: _withCtx(() => [
                  _hoisted_31,
                  _createVNode(_component_LogoutIcon, { class: "h-5 w-5 ml-2 -mr-1" })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.user)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0,
          user: _ctx.user,
          isAdmin: _ctx.isAdmin
        }, null, 8, ["user", "isAdmin"]))
      : _createCommentVNode("", true)
  ]))
}